module.exports = __webpack_public_path__ + "static/media/cb-mobile.6cbfeb05.png";